import { gql, useQuery } from '@apollo/client';

import { ResultType, LoadedResults } from '../screens/Results/Results.types';
import { isAMH } from 'kb-shared/utilities/appointment.helper';
import { usePatientAppointments } from 'screens/Dashboard/Dashboard.hooks';

type ResponseData = {
  results: LoadedResults;
};

const ResultsQuery = gql`
  query useResults {
    results {
      afc: follicleCounts {
        name
        date
        units
        value
      }
      labs {
        type
        name
        date
        units
        value
        normalRange
        category
        categoryDisplayName
      }
    }
  }
`;

const useResults = () => {
  const { data } = useQuery<ResponseData>(ResultsQuery);
  const { data: appointmentsData, loading } = usePatientAppointments();

  if (loading)
    return {
      afcResult: undefined,
      amhResult: undefined,
      hasScheduledAmh: undefined,
      loading
    };

  const hasScheduledAmh = appointmentsData?.appointments.some(a => isAMH(a)) || false;

  if (!data) {
    return {
      afcResult: undefined,
      amhResult: undefined,
      hasScheduledAmh,
      loading
    };
  }

  const { results } = data;
  const afcResult = results.afc[0];
  const amhResult = results.labs.find((value: ResultType) => {
    return value.type === 'amh';
  });

  return {
    afcResult,
    amhResult,
    hasScheduledAmh,
    loading
  };
};

export { useResults };
export default useResults;
